import { useMemo } from 'react';
import {UserManager } from './UserManagerContext'
export function useUserManager() {

    const userManager = useMemo(() => new UserManager(), []);

    return userManager;
}
